import { apiGeeDomain, poaUrl } from '../config/connections'
import { getRoutingKey } from './sessionUtils'
import {
  OnboardingSuccessInfoLogger,
  OnboardingErrorInfoLogger
} from './loggerUtils'

/* eslint-disable-next-line */
export const updateOnboardingFeature = () => {
  const updatePartnerOnboarding = {
    requestType: {
      serviceType: 'ONBOARDING_FEATURE',
      serviceSubType: 'UPDATE_ONBOARDING_FEATURE'
    },
    data: {
      code: 'DIY_BILLPAY',
      status: 'COMPLETED',
      program: 'DIY'
    }
  }

  const AccessToken = sessionStorage.getItem('AccessToken') || ''

  fetch(`${apiGeeDomain}services/customer-management/servicing/v1`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${AccessToken}`,
      routingKey: getRoutingKey() || '',
      'Content-Type': 'application/json'
    },

    body: JSON.stringify(updatePartnerOnboarding)
  })
    .then((res) => {
      OnboardingSuccessInfoLogger(
        'DIY_BILLPAY',
        'Partner onboarding API Success'
      )
      // eslint-disable-next-line no-console
      console.log('POA response:', res)
    })
    .catch((e) => {
      OnboardingErrorInfoLogger('DIY_BILLPAY', 'Partner onboarding API Failed')
      // eslint-disable-next-line no-console
      console.log('POA Error:', e)
    })
}

/* eslint-disable-next-line */
export const updateOnboardingFeatureNew = (successCallback, failureCallback) => {
  return new Promise((resolve) => {
    const updatePartnerOnboarding = {
      requestType: {
        serviceType: 'ONBOARDING_FEATURE',
        serviceSubType: 'UPDATE_ONBOARDING_FEATURE'
      },
      data: {
        code: 'DIY_BILLPAY',
        status: 'COMPLETED',
        program: 'DIY'
      }
    }

    const AccessToken = sessionStorage.getItem('AccessToken') || ''

    fetch(`${apiGeeDomain}${poaUrl}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${AccessToken}`,
        routingKey: getRoutingKey() || '',
        'Content-Type': 'application/json'
      },

      body: JSON.stringify(updatePartnerOnboarding)
    })
      .then(() => {
        successCallback()
        OnboardingSuccessInfoLogger(
          'DIY_BILLPAY',
          'Partner onboarding API Success'
        )
        resolve({ status: 'SUCCESS' })
      })
      .catch(() => {
        failureCallback()
        OnboardingErrorInfoLogger(
          'DIY_BILLPAY',
          'Partner onboarding API Failed'
        )
        resolve({ status: 'FAILED' })
      })
  })
}
